require('./change_palette.js');

PegasusTemplate.ClearRowsCommand = PegasusTemplate.GlobalManipulationCommand.extend({
  descriptionClass: 'delete',
  description: function(){
    return Em.I18n.t('command_descriptions.cleared_all_rows');
  }.property()
});

//PegasusTemplate.ClearRowsCommand.create({
  //backup: PegasusTemplate.blockRegionInstance.mutateForOut().editor_cookie,
  //parent: Pegaus.blockRegionInstance.get('parentView')
//});
